module.exports = __webpack_public_path__ + "img/md-cog.c952e3bb.svg";